app.service('basketWarranty', function (orderConfig, cartManager, warrantyEncouragement, log, broker) {
	function change(value, productId) {
		$(`#warranty-${productId}`)
			.val(value)
			.change();
	}

	function open(params) {
		warrantyEncouragement.load({
			productId: params.productId,
			mainCartItemId: params.mainCartItemId,
			packageIdentifier: params.packageIdentifier,
			relatedPromotionIdentifier: params.relatedPromotionIdentifier,
			variant: params.variant,
			defaultSelectedWarranty: params.defaultSelectedWarranty,
			showGradeInfoFromCart: params.showGradeInfoFromCart,
			categoryGradeInfoFromCart: params.categoryGradeInfoFromCart,
			callback: function (action, data) {
				if (action == 'UPDATE' || action == 'ADD') {
					add({
						mainCartItemId: params.mainCartItemId,
						quantity: data.quantity,
						warrantyId: data.warrantyId,
						packageIdentifier: params.packageIdentifier ? params.packageIdentifier : undefined,
						relatedPromotionIdentifier: params.relatedPromotionIdentifier ? params.relatedPromotionIdentifier : undefined,
						warrantyPaymentType: data.warrantyPaymentType,
						productPlu: params.productPlu,
						isProductInstallmentPrice: params.isProductInstallmentPrice,
						place: 'warranty_details'
					});
				} else {
					cartManager.warrantyAction({
						mainCartItemId: params.mainCartItemId,
						warrantyId: data.warrantyId,
						action: 'REMOVE_MAIN_CART_ITEM_WARRANTY',
						addedFrom: 'TO_CART',
						warrantyPaymentType: ''
					}, function () {
						log.event({
							id: 'remove_cart',
							f03: 'cart_step_1',
							f04: data.warrantyId,
							f05: 'warranty',
							f06: params.productPlu,
							f07: 'warranty_details',
							f08: 'fancybox',
							f09: 'new',
							f10: data.warrantyPaymentType == 'POSTPONED' || orderConfig.getData().basketType != 'COMMON' ? 'installment' : data.warrantyPaymentType == 'ONE_TIME' ? 'cash' : 'subscription'
						});
						broker.trigger('REFRESH_BASKET_VIEW');
					});
				}
			}
		});
	}
	function add(params){
		var config = orderConfig.getData();
		cartManager.warrantyAction({
			mainCartItemId: params.mainCartItemId,
			quantity: params.quantity ? params.quantity : $('#warranty-'+params.mainCartItemId).val(),
			warrantyId: params.warrantyId,
			packageIdentifier: params.packageIdentifier ? params.packageIdentifier : undefined,
			relatedPromotionIdentifier: params.relatedPromotionIdentifier ? params.relatedPromotionIdentifier : undefined,
			action: params.packageIdentifier ? 'OVERWRITE_PACKAGE_WARRANTY' : 'OVERWRITE_MAIN_CART_ITEM_WARRANTY',
			addedFrom: params.addedFrom ? params.addedFrom : 'TO_CART',
			warrantyAddedFrom: config.basketType == 'MIXED' ? 'CART_EDIT_MIXED' : (config.basketType == 'INSTALLMENT' ? 'CART_EDIT_INSTALLMENT' : 'CART_EDIT_COMMON'),
			warrantyPaymentType: params.warrantyPaymentType
		}, function () {
			log.event({
				id: 'to_cart',
				f03: 'cart_step_1',
				f04: params.warrantyId,
				f05: 'warranty',
				f06: params.productPlu,
				f07: params.place ? params.place : '',
				f08: 'fancybox',
				f09: 'new',
				f10: params.warrantyPaymentType == 'POSTPONED' || params.isProductInstallmentPrice ? 'installment' : params.warrantyPaymentType == 'ONE_TIME' ? 'cash' : 'subscription' ,
			});
			broker.trigger('REFRESH_BASKET_VIEW');
		});
	}
	return {
		change,
		open,
		add
	};
});
